import { ResponseModel } from 'common/interfaces';
import { useFetch } from 'hooks/use-fetch/use-fetch';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { incomingInvoiceConfig } from 'request-config/incoming-invoice/incoming-invoice.request-config';
import { GetLookupByColumnNameRequestData } from 'request-config/incoming-invoice/incoming-invoce.props';
import { RequestStatuses } from '@/constants';
import { GetLookupByColumnNameQueryResponse } from './get-lookup-by-column-name.types';
import { useQuery as useUrlQuery } from '@/hooks';

const modifyResponse = <T>({ data }: AxiosResponse<ResponseModel<GetLookupByColumnNameQueryResponse<T>>>) => {
  if (data.level === RequestStatuses.Success) {
    return data.data.items;
  }

  return [];
};

const useGetLookupByColumnNameQuery = <T>(
  props: GetLookupByColumnNameRequestData,
  options: { enabled?: boolean } = {}
) => {
  const query = useUrlQuery();
  const invoiceId = query.id as string;

  const { fetch } = useFetch<ResponseModel<GetLookupByColumnNameQueryResponse<T>>>({
    loadingKey: `useGetLookupByColumnNameQuery${JSON.stringify(props)}`,
    isShowLoading: false,
    ...incomingInvoiceConfig.getLookupByColumnName({ ...props, uds_eingangsrechnungid: invoiceId })
  });

  const { data, ...restQueryProps } = useQuery<
    AxiosResponse<ResponseModel<GetLookupByColumnNameQueryResponse<T>>>,
    unknown,
    T[]
  >({
    queryKey: ['useGetLookupByColumnNameQuery', props],
    queryFn: fetch,
    select: modifyResponse,
    ...options
  });

  return {
    query: data || [],
    ...restQueryProps
  };
};

export default useGetLookupByColumnNameQuery;
